export const CSR_TOOLBAR_HEIGHT_VAR = "--csr-toolbar-height";
export const CSR_TOOLBAR_HEIGHT = `var(${CSR_TOOLBAR_HEIGHT_VAR}, 0px)`;
